import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_qatwquj9mz: FaireBrandEntity = {
  token: "b_qatwquj9mz",
  type: "brand",
  name: "Biquette",
  avatarUrl:
    "https://cdn.faire.com/fastly/7af86b27cf447b5d5bd94a0afc76093d8e77937408fa98f7d17257e27090b3c2.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/633af4f300eabc75cd5190e77199854ea1aac143856577b78fd8f3319ffab4ac.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7af86b27cf447b5d5bd94a0afc76093d8e77937408fa98f7d17257e27090b3c2.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/633af4f300eabc75cd5190e77199854ea1aac143856577b78fd8f3319ffab4ac.jpeg",
  location: "Mineola, NY, USA",
  minimumOrderDollars: 200,
  rating: 5,
  reviewCount: 2,
  isTopShop: true,
  isInsider: true,
  description:
    "At Biquette, we create artful knit blankets and scarves that blend exceptional craftsmanship with inspired design. Collaborating with visual artists, we transform their work into soft, vibrant textiles that elevate everyday living. Thoughtfully made in the USA, we use only natural fibers, and each piece is made to order to reduce textile waste.\n\nWhether you're adding a cozy touch to your home, accessorizing with a unique flair, or searching for a meaningful gift, Biquette’s designs bring creativity and comfort to every aspect of life. Wrap yourself in pieces that are not only warm but also sustainable works of art.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:57:50.481Z",
    importedBy: "entity-db-cli",
  },
};
